export const ApplicationLink = {
    "请选择应用环节":"請選擇應用環節",
    "添加应用环节":"添加應用環節",
    "请输入应用环节":"請輸入應用環節",
    "确定要删除应用环节":"確定要刪除應用環節",
    "删除后将不可恢复":"刪除後將不可恢復",
}